import { useFm } from '@web3/base-hooks';

type FormItem = {
  label?: string;
  fieldKey: string;
  required?: boolean;
  type: 'input' | 'textarea' | 'upload';
  placeholder?: string;
  long?: boolean;
  maxLength?: number;
  rows?: number;
  disabled?: boolean;
  inputType?: 'text' | 'password' | 'number';
};

export const useConstent = () => {
  const fm = useFm();
  const formBase: FormItem[] = [
    {
      label: fm('fundRecipient'),
      fieldKey: 'entityName',
      required: true,
      type: 'input',
      placeholder: fm('cryptoPlatforms'),
    },
    {
      label: fm('recipientAddress'),
      fieldKey: 'entityUserAddress',
      required: true,
      type: 'input',
      placeholder: fm('enterRecipientWalletAddr'),
    },
    {
      label: fm('fundAmountTokenLevel'),
      fieldKey: 'fundAmount',
      type: 'input',
      required: true,
      placeholder: '0',
      inputType: 'number',
    },
    {
      label: fm('stolenFundsTokenName'),
      fieldKey: 'fundTokenName',
      required: true,
      type: 'input',
      placeholder: fm('enterTokenName'),
    },
    {
      label: fm('relatedTxHash'),
      fieldKey: 'relatedTxHash',
      required: true,
      type: 'textarea',
      long: true,
      maxLength: 10000,
      rows: 4,
      placeholder: `${fm('enterTxHashFormat')}
${fm('chainNameTxHashNote', {
  content1: 'A',
  content2: 'A',
})}
${fm('chainNameTxHashNoteB')}
...
`,
    },
    {
      label: fm('yourName'),
      fieldKey: 'reporterName',
      required: false,
      type: 'input',
      placeholder: fm('enterPageNameAppear'),
    },
    {
      label: fm('contactInfo'),
      fieldKey: 'reportContactInfo',
      required: false,
      type: 'input',
      placeholder: fm('enterEmailOrTgAccount'),
    },
  ];
  const formAdditional: FormItem[] = [
    {
      label: fm('attachmentInPngJpg'),
      fieldKey: 'reportFile',
      required: false,
      type: 'upload',
      long: true,
    },
    {
      label: fm('reportText'),
      fieldKey: 'reportText',
      required: false,
      type: 'textarea',
      long: true,
      maxLength: 10000,
      rows: 3,
      placeholder: fm('addRelevantDetails'),
    },
  ];
  const formList = [...formBase, ...formAdditional];

  return { formBase, formAdditional, formList };
};
